import { View } from 'react-native';
import {
  Button,
  Container,
  ProfileHeader,
  ScrollingView,
  Spacing,
  Typography,
} from 'components/src';
import {
  Platform,
  createUseStyles,
  logOut,
  routesName,
  storeToken,
  useGetUserGetUserProfile,
  usePostLoginLogout,
} from 'core/src';
import React, { useReducer, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { toggleScroll, initialState, reducer } from '../store';
import { ProfileAccount } from '../../molecules/profileAccount';
import { ProfileSetting } from './components/profileSetting';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import FontAwesome5_Regular from 'react-native-vector-icons/FontAwesome5';
import { StackNavigationProp } from '@react-navigation/stack';
import { SocketIOContext } from '../../app/appcontainer';

const MaterialIconsX = MaterialIcons as unknown as React.ComponentType<any>;
const FontAwesome5_RegularX =
  FontAwesome5_Regular as unknown as React.ComponentType<any>;

interface ProfileProps {
  navigation: StackNavigationProp<any>;
  setOpen?: any;
  dispatching?: any;
  setInfo?: any;
  setOpenChat?: any;
}

const ProfileScreen: React.FC<ProfileProps> = ({
  navigation,
  setOpen,
  dispatching,
  setInfo,
  setOpenChat,
}) => {
  const { styles, colors } = useStyles();
  const { i18n } = useTranslation();
  const [{ scrolled }, dispatch] = useReducer(reducer, initialState);
  const { data, refetch } = useGetUserGetUserProfile({
    refetchOnWindowFocus: false,
  });

  const handleScroll = (event: any) => {
    if (event.nativeEvent.contentOffset.y > 20) {
      dispatch(toggleScroll(true));
    } else {
      dispatch(toggleScroll(false));
    }
  };
  const logOutDispatch = storeToken.useDispatch();

  const { mutate } = usePostLoginLogout({
    onSuccess: async (data) => {
      logOutDispatch(logOut());
    },
  });

  const handleChatInfo = (event: any) => {
    const avatar = '37329gb39782gd3gbd382gd@@saved_messages_pic.png';

    dispatching(
      setInfo({
        name: i18n.t('savedMessage'),
        chatId: event?.id,
        avatar: avatar,
        status: '',
      }),
    );
    setOpenChat('chat');
    setOpen('');
    // setTimeout(() => {
    //   setOpenChat('chat');
    // }, 200);
  };

  const SaveMessage = () => {
    SocketIOContext.invoke('addConversation', {
      type: 'savedMessages',
    });
  };

  SocketIOContext.useSocketEffect<any, any>(
    'addConversation',
    (event: any): any => {
      SocketIOContext.invoke('findConversations', {
        pageNumber: '1',
        pageSize: '200',
      });
      Platform.isDesktop
        ? handleChatInfo(event)
        : navigation.navigate(routesName.CHAT, {
            name: i18n.t('savedMeeages'),
            chatId: event?.id,
            avatar: '37329gb39782gd3gbd382gd@@saved_messages_pic.png',
            status: '',
          });
    },
    [],
  );

  // const { mutate: mutateSaved } = usePostChatSavedMessage({
  //   onSuccess: async (data) => {
  //     SocketIOContext.invoke('findConversations', {
  //       pageNumber: '1',
  //       pageSize: '200',
  //     });
  //     Platform.isDesktop
  //       ? setOpen('')
  //       : navigation.navigate(routesName.CONVERSATIONS);
  //   },
  //   onError: async (data) => {
  //     Platform.isDesktop
  //       ? setOpen('')
  //       : navigation.navigate(routesName.CONVERSATIONS);
  //   },
  // });

  const userLogout = useCallback(() => {
    mutate({});
  }, []);
  return (
    <Container>
      <View style={styles.container}>
        <ProfileHeader
          refetch={refetch}
          data={data?.data}
          setOpen={setOpen}
          navigation={navigation}
          scrolled={scrolled}
          setProfilePic={true}
        />
        <ScrollingView onScroll={handleScroll} scrollEventThrottle={16}>
          <Spacing vertical={50} />

          <ProfileAccount
            bioEdit={true}
            nameAndFamily={data?.data?.nameAndFamily}
            userName={data?.data?.userName}
            _bio={data?.data?.bio}
            loadData={refetch}
          />
          <View style={styles.box}>
            <Button
              onClick={() => {
                Platform.isDesktop
                  ? setOpen('contact')
                  : navigation.navigate(routesName.CONTACT);
              }}
            >
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <View style={styles.icon}>
                  <MaterialIconsX
                    name="contact-page"
                    size={25}
                    color={colors.color01}
                  />
                </View>
                <Spacing horizontal={2} />
                <Typography
                  text={i18n.t('contact')}
                  weight={'bold'}
                  margin={3}
                  color={colors.primaryColor}
                />
              </View>
            </Button>
          </View>

          <View style={styles.box}>
            <Button onClick={SaveMessage}>
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <View style={styles.icon}>
                  <MaterialIconsX
                    name="cloud"
                    size={25}
                    color={colors.color01}
                  />
                </View>
                <Spacing horizontal={2} />
                <Typography
                  text={i18n.t('savedMessage')}
                  weight={'bold'}
                  margin={3}
                  color={colors.primaryColor}
                />
              </View>
            </Button>
          </View>

          <ProfileSetting statusDefualt={data?.data?.situation} />

          <View style={styles.box}>
            <Button onClick={userLogout}>
              <View style={{ elevation: 3 }}>
                <View
                  style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <View style={styles.icon}>
                    <FontAwesome5_RegularX
                      name="sign-out-alt"
                      size={25}
                      color={colors.color01}
                    />
                  </View>
                  <Spacing horizontal={2} />
                  <Typography
                    text={i18n.t('logout')}
                    weight={'bold'}
                    // margin={3}
                    color={colors.primaryColor}
                  />
                </View>
              </View>
            </Button>
          </View>
        </ScrollingView>
      </View>
    </Container>
  );
};
const useStyles = createUseStyles(({ colors, theme }) => ({
  container: {
    flex: 1,
    backgroundColor: colors.container,
  },
  list: {
    padding: 5,
  },
  listDesc: {
    padding: 15,
  },
  box: {
    padding: 10,
    margin: 10,
    borderRadius: 20,
    backgroundColor: colors.drawerHeaderBox,
  },
  icon: { padding: 10 },
}));

export { ProfileScreen };
